import { BROADCAST_TOGGLE_MULTIPLE_AGORA_ATTENDEE_CAMERA_STATUSES } from 'actions/Types';
import { AGORA_CAMERA_STATUS_CHANGE } from '@shoflo/studio-redux/constants/SocketEvents';
import { setAttendeeCameraStatus } from '@shoflo/studio-redux/actions';
import { toggleLocalUserVideoTrack } from '@shoflo/studio-redux/utils';
import { UNASSIGNED } from 'utils/broadcastSourceHelper';
import { StudioLogger } from '@studio/logger';
import { MIXER_ATTENDEES_CAMERA_STATUS_CHANGE } from 'store/eventConstants';

const LOG = new StudioLogger('toggleMultipleAgoraAttendeeCameraStatuses');

const toggleMultipleAgoraAttendeeCameraStatuses = cameraStatuses => {
  return (dispatch, getState, socket) => {
    const { broadcast, meeting, attendeeCameraStatus } = getState();
    const broadcastId = broadcast && broadcast._id;
    const localAttendeeId = meeting.attendeeId;
    const client = meeting.client;
    const localVideoTrack = meeting?.client?.localTracks?.find(
      ({ trackMediaType }) => trackMediaType === 'video'
    );

    const unassignedCameraStatuses = filterUnassignedSources(cameraStatuses);

    const action = {
      type: BROADCAST_TOGGLE_MULTIPLE_AGORA_ATTENDEE_CAMERA_STATUSES,
      request: async () => {
        for (const [attendeeId, isCameraOn] of Object.entries(cameraStatuses)) {
          const payload = {
            attendeeId,
            isCameraOn,
            broadcastId
          };

          try {
            const isLocalUser = attendeeId === localAttendeeId;

            if (isLocalUser) {
              await toggleLocalUserVideoTrack({
                currentVideoTrack: localVideoTrack,
                isCameraOn,
                client,
                dispatch,
                attendeeId
              });
            }

            socket.emit(AGORA_CAMERA_STATUS_CHANGE, payload);

            if (attendeeId.includes(UNASSIGNED)) {
              dispatch(setAttendeeCameraStatus(attendeeId, isCameraOn));
            }
          } catch (error) {
            LOG.error(
              `Failed to toggle Agora attendee camera status for attendeeId: ${attendeeId}`,
              error
            );
            throw error;
          }
        }

        socket.emit(MIXER_ATTENDEES_CAMERA_STATUS_CHANGE, {
          broadcastId,
          attendeesCameraStatus: {
            ...attendeeCameraStatus,
            ...cameraStatuses
          }
        });

        return Object.create(null);
      },
      payload: unassignedCameraStatuses
    };

    dispatch(action);
  };
};

const filterUnassignedSources = cameraStatuses =>
  Object.keys(cameraStatuses)
    .filter(key => key.includes(UNASSIGNED))
    .reduce((acc, key) => {
      acc[key] = cameraStatuses[key];
      return acc;
    }, {});

export default toggleMultipleAgoraAttendeeCameraStatuses;
